var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayersIconWithShadow = function SvgLayersIconWithShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#layers-icon-with-shadow_svg__a)",
    fillRule: "evenodd",
    d: "M37.453 30.904a2 2 0 0 1 2.769-.577l12.207 8a2 2 0 0 1-.084 3.398L33.01 53.06a2 2 0 0 1-2.023 0L11.655 41.725a2 2 0 0 1-.098-3.39l12-8a2 2 0 1 1 2.219 3.33l-9.34 6.226L32 49.015l15.54-9.11-9.51-6.232a2 2 0 0 1-.577-2.77Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#layers-icon-with-shadow_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.14,
    strokeWidth: 0.6,
    d: "M16.269 39.641a.3.3 0 0 0 .015.509l15.564 9.124a.3.3 0 0 0 .304 0l15.54-9.11a.3.3 0 0 0 .012-.51l-9.51-6.232a1.7 1.7 0 0 1 1.863-2.844l12.208 8a1.7 1.7 0 0 1-.072 2.889L32.86 52.8a1.7 1.7 0 0 1-1.72 0L11.807 41.467a1.7 1.7 0 0 1-.084-2.881l12-8a1.7 1.7 0 0 1 1.887 2.828l-9.341 6.227Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#layers-icon-with-shadow_svg__c)",
    fillRule: "evenodd",
    d: "M30.989 10.941a2 2 0 0 1 2.022 0l19.334 11.334a2 2 0 0 1 0 3.45L33.01 37.06a2 2 0 0 1-2.022 0L11.655 25.726a2 2 0 0 1 0-3.451L30.99 10.94ZM16.62 24.001 32 33.014 47.379 24 32 14.985 16.621 24Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#layers-icon-with-shadow_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.14,
    strokeWidth: 0.6,
    d: "M16.47 23.741a.3.3 0 0 0 0 .518l15.378 9.015a.3.3 0 0 0 .304 0l15.378-9.015a.3.3 0 0 0 0-.518l-15.378-9.015a.3.3 0 0 0-.304 0L16.47 23.741Zm14.67-12.54a1.7 1.7 0 0 1 1.72 0l19.333 11.332a1.7 1.7 0 0 1 0 2.934L32.86 36.8a1.7 1.7 0 0 1-1.72 0L11.807 25.467a1.7 1.7 0 0 1 0-2.933L31.14 11.2Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "layers-icon-with-shadow_svg__a",
    x1: 32,
    x2: 60.5,
    y1: 32,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layers-icon-with-shadow_svg__b",
    x1: 32,
    x2: 11,
    y1: 30,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layers-icon-with-shadow_svg__c",
    x1: 34.5,
    x2: 4,
    y1: 24,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layers-icon-with-shadow_svg__d",
    x1: 12.5,
    x2: 51.552,
    y1: 24,
    y2: 28.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgLayersIconWithShadow;